import type { IDomains } from "../MarketBuilder.types";
import { ESelectDomainOptions } from "../MarketBuilder.types";

export const countTabSource = (selectedDomains: IDomains) => {
    let websitesCount = 0,
        industryCount = 0;

    selectedDomains.forEach((domain) => {
        switch (domain.section) {
            case ESelectDomainOptions.WEBSITE:
            case ESelectDomainOptions.MANUAL:
                websitesCount++;
                break;

            case ESelectDomainOptions.INDUSTRY:
                industryCount++;
                break;

            default:
                break;
        }
    });

    return { websitesCount, industryCount };
};
